import Splide from "@splidejs/splide";

function initSliderSteps(context) {
	const root = context && typeof context.querySelectorAll === "function" ? context : document;
	root.querySelectorAll(".splide-steps").forEach((el) => {
		const stepsSlider = new Splide(el, {
			perPage: "auto",
			gap: "clamp(1.0625rem,-.0833333333rem + 3.6666666667vw,3.125rem)",
			pagination: true,
			arrows: true,
			snap: true,
			focus: "left",
			autoplay: false,
			interval: 6000,
			omitEnd: true,
			speed: 700,
		});

		stepsSlider.on("overflow", function (isOverflow) {
			stepsSlider.options = {
				arrows: isOverflow,
				pagination: isOverflow,
				drag: isOverflow,
			};
		});

		stepsSlider.mount();

	});
}

// Front-end
document.addEventListener("DOMContentLoaded", () => initSliderSteps());

// Gutenberg / ACF editor
if (window.acf) {
	window.acf.addAction("render_block_preview/type=bloc-steps", ($block) => {
		initSliderSteps($block && $block.jquery ? $block.get(0) : $block);
	});
}
